import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import type { Fleet } from "../../types/auth";
import { apiService } from "../../services/api";

interface UserFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  roleFilter: string;
  onRoleFilterChange: (value: string) => void;
  fleetFilter: string;
  onFleetFilterChange: (value: string) => void;
  activeOnly: boolean;
  onActiveOnlyChange: (value: boolean) => void;
}

export const UserFilters: React.FC<UserFiltersProps> = ({
  search,
  onSearchChange,
  roleFilter,
  onRoleFilterChange,
  fleetFilter,
  onFleetFilterChange,
  activeOnly,
  onActiveOnlyChange,
}) => {
  const [fleets, setFleets] = useState<Fleet[]>([]);

  useEffect(() => {
    apiService
      .getFleets()
      .then((r) => setFleets(r.fleets || []))
      .catch(console.error);
  }, []);

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex flex-wrap gap-4 items-end">
      <div className="relative flex-1 min-w-[200px]">
        <label className="block text-xs font-medium text-gray-500 mb-1">
          Email search
        </label>
        <Search className="absolute left-3 top-8 h-4 w-4 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by email..."
          className="w-full border border-gray-300 rounded-md pl-9 pr-3 py-2 text-sm"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          Role
        </label>
        <select
          value={roleFilter}
          onChange={(e) => onRoleFilterChange(e.target.value)}
          className="border border-gray-300 rounded-md px-3 py-2 text-sm min-w-[120px]"
        >
          <option value="">All roles</option>
          <option value="admin">Admin</option>
          <option value="fleet">Fleet</option>
          <option value="user">User</option>
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          Fleet
        </label>
        <select
          value={fleetFilter}
          onChange={(e) => onFleetFilterChange(e.target.value)}
          className="border border-gray-300 rounded-md px-3 py-2 text-sm min-w-[160px]"
        >
          <option value="">All fleets</option>
          {fleets.map((f) => (
            <option key={f.id} value={f.id}>
              {f.name}
            </option>
          ))}
        </select>
      </div>
      <label className="flex items-center gap-2 text-sm text-gray-700 pb-2">
        <input
          type="checkbox"
          checked={activeOnly}
          onChange={(e) => onActiveOnlyChange(e.target.checked)}
          className="rounded border-gray-300"
        />
        Active only
      </label>
    </div>
  );
};
